import {useLiveQuery} from 'dexie-react-hooks';
import {readSnapshot} from './offlineQuery';
import {getReadySession} from './offlineSessionManager';
import {PERSONNEL_SECTION_SOURCES} from './personnelSources';
import {projectScopeId} from './projectScope';

/**
 * Live availability of a cached personnel section from any offline domain:
 * `undefined` while online or resolving, `false` when every section is missing
 * or was captured under another project scope.
 */
export const useOfflinePersonnelAvailable = (
  isOffline: boolean
): boolean | undefined => {
  // Read per render rather than from the store hook: this runs inside form
  // fields that are not wrapped in a redux Provider.
  const scopeId = projectScopeId();

  return useLiveQuery(async () => {
    if (!isOffline) return undefined;
    for (const source of PERSONNEL_SECTION_SOURCES) {
      const session = await getReadySession(source.contextKey);
      if (!session) continue;
      const snapshot = await readSnapshot(session.id, source.snapshotKey);
      const section = snapshot?.data as {scopeProjectId?: number} | undefined;
      const inScope =
        (section?.scopeProjectId ?? undefined) === (scopeId ?? undefined);
      if (section && inScope) return true;
    }
    return false;
  }, [isOffline, scopeId]);
};
